import { Auth0Context, withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ComponentType, useContext } from "react";
import { LMLayout } from "../../layout/LMLayout";
import { Loader } from "../../components";
import { ConfigContext } from "../config/context";

interface ProtectedRouteProps {
  component: ComponentType;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component,
}) => {
  const { authDomain, clientId } = useContext(ConfigContext);
  const { isAuthenticated } = useContext(Auth0Context);
  if (!authDomain || !clientId) {
    const Component = component;
    return (
      <LMLayout>
        <Component />
      </LMLayout>
    );
  }
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loader />,
  });

  if (!isAuthenticated) return <Component />;

  return (
    <LMLayout>
      <Component />
    </LMLayout>
  );
};
